if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this._touchStartX = 0;
      this._touchEndX = 0;
      this._navCreated = false;
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
      this._setupSwipe();
      this._setupNav();
      this._updateCounter();
    }

    _getAllMedia() {
      return Array.from(this.querySelectorAll('[data-media-id]'));
    }

    _getActiveMedia() {
      return this.querySelector('[data-media-id].active');
    }

    _setActive(element) {
      this._getAllMedia().forEach(el => el.classList.remove('active'));
      element.classList.add('active');
      this._updateCounter();
    }

    _navigate(direction) {
      const all = this._getAllMedia();
      const active = this._getActiveMedia();
      if (!active) return;
      const idx = all.indexOf(active);
      const next = idx + direction;
      if (next >= 0 && next < all.length) {
        this._setActive(all[next]);
      }
    }

    _setupSwipe() {
      if (this._swipeReady) return;
      this._swipeReady = true;
      const content = this.querySelector('.product-media-modal__content');
      if (!content) return;

      content.addEventListener('touchstart', (e) => {
        this._touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      content.addEventListener('touchend', (e) => {
        this._touchEndX = e.changedTouches[0].screenX;
        const diff = this._touchStartX - this._touchEndX;
        if (Math.abs(diff) > 50) {
          this._navigate(diff > 0 ? 1 : -1);
        }
      }, { passive: true });

      // Keyboard arrows
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') this._navigate(1);
        if (e.key === 'ArrowLeft') this._navigate(-1);
      });
    }

    _setupNav() {
      if (this._navCreated) return;
      this._navCreated = true;

      const dialog = this.querySelector('.product-media-modal__dialog');
      if (!dialog) return;

      const navHTML = `
        <button type="button" class="pkw-modal-nav pkw-modal-nav--prev" aria-label="Vorheriges Bild">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <button type="button" class="pkw-modal-nav pkw-modal-nav--next" aria-label="Nächstes Bild">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
        <div class="pkw-modal-counter"></div>
      `;
      dialog.insertAdjacentHTML('beforeend', navHTML);

      dialog.querySelector('.pkw-modal-nav--prev').addEventListener('click', () => this._navigate(-1));
      dialog.querySelector('.pkw-modal-nav--next').addEventListener('click', () => this._navigate(1));
    }

    _updateCounter() {
      const counter = this.querySelector('.pkw-modal-counter');
      if (!counter) return;
      const all = this._getAllMedia();
      const active = this._getActiveMedia();
      if (!active) return;
      const idx = all.indexOf(active) + 1;
      counter.textContent = `${idx} / ${all.length}`;
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
